<template>
    <el-row>
        <el-col :span="8" style="padding-right: 10px">
            <el-card class="box-card">
                <div class="user">
                    <img src="../assets/image/user.jpg" alt="">
                    <div class="userinfo">
                        <p class="name">{{username}}</p>
                    <p class="access">{{limit}}</p>
                    </div>
                </div>
                <div class="login-info">
                    <p>上次登录时间：<span></span></p>
                    <p>上次登录地点：<span></span></p>
                </div>
            </el-card>
            
        </el-col>
        <el-col :span="16" style="padding-left: 10px">
            <div class="num">
                <el-card v-for="item in DataTotal" :key="item.name" :body-style="{ display: 'flex', padding: 0 }">
                <i class="icon" :class="`el-icon-${item.icon}`" :style="{ background: item.color }"></i>
                    <div class="detail">
                        <p class="price">{{ item.value }}</p>
                        <p class="desc">{{ item.name }}</p>
                    </div>
                </el-card>
            </div>
            
            
        </el-col>
    </el-row>



</template>
<script>
	
export default {
    data() {
        return {
            username:'',
            limit:'',
            DataTotal: [
                
                
            ],
        }
        

    },
    mounted() {
      
     },
     created() {
        this.username=window.sessionStorage.getItem('username');
        this.request.get("/getDataTotal").then(res => {
		console.log(res)    
        this.DataTotal=res.info;
	   													
	   				}).catch(error => { console.log(error)})

        this.request.get("/getLimitByUsername",{params:{"username":this.username}}).then(res => {
                        if(res.code=="0"){
                            if(res.data=="1"){
                               this.limit="超级管理员" 
                            }
                            if(res.data=="0"){
                               this.limit="普通会员" 
                            }
                        }
	   													
	   				}).catch(error => { console.log(error)})           
      
    },
}
</script>
<style lang="less" scoped>
.user {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    img {
        margin-right: 40px;
        width: 150px;
        height: 150px;
        border-radius: 50%;
    }
    .userinfo {
        .name {
            font-size: 32px;
            margin-bottom: 10px;
        }
        .access {
            color: #999999;
        }
    }
}
.login-info {
    p {
        line-height: 28px;
        font-size: 14px;
        color: #999999;
        span {
            color: #666666;
            margin-left: 60px;
        }
    }
}
.num {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .icon {
        width: 80px;
        height: 80px;
        font-size: 30px;
        color: #fff;
        text-align: center;
        line-height: 80px;
    }
    .detail {
        margin-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .price {
            padding: none;
            font-size: 30px;
            margin-top: 10px;
            margin-bottom: 10px;
            line-height: 30px;
            height: 30px;
        }
        .desc {
            font-size: 13px;
            color: #999;
            text-align: center;
        }
    }
    .el-card {
        width: 32%;
        margin-bottom: 20px;
    }
}
.graph {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .el-card {
        width: 48%
    }
}
</style>
